import React from 'react'
import { FieldProps } from '../../../../../../@types/types'
import { OtherFacilitiesScreenValidationResult } from '../../../../../../@types/validation-types'
import { Stepper } from '../../../../../common/inputs/stepper/Stepper'
import { getDefaultClasses } from '../../../../../../utils/style-utils'
import { OtherFacilitiesWrapperProps } from '../../otherFacilities/OtherFacilities'
import { isWebView } from '../../../../../../utils/navigation'
import { useTranslation } from 'react-i18next'

const BathroomField: React.FC<FieldProps<OtherFacilitiesScreenValidationResult>> = ({
  validationMessages,
  insertionData,
  screenName,
  onChange,
  wrapperClassName = getDefaultClasses('right'),
}) => {
  const { t } = useTranslation()

  const isMobileView = isWebView()

  return (
    <div className={wrapperClassName}>
      <Stepper
        id='no-bathrooms'
        propertyName='noBathrooms'
        placeholder={isMobileView ? t('wizard.screen.objectDetails.placeholder.amount') : ''}
        label='wizard.screen.otherFacilities.noBathrooms'
        input={insertionData.noBathrooms}
        type='tel'
        numericOnly
        maxLength={3}
        max={99}
        errors={validationMessages!.noBathrooms ?? []}
        doOnFieldChange={(property, value) => onChange({ screen: screenName, property }, value)}
      />
    </div>
  )
}

export const bathroomField = (wrapperClassName?: string) => (props: OtherFacilitiesWrapperProps) => (
  <BathroomField {...props} wrapperClassName={wrapperClassName} />
)

export default BathroomField
